import React from "react";
import PropTypes from "prop-types";

const CourseCard = ({
  thumbnail,
  title,
  progress,
  instructor,
  category,
  status,
  completedLessons = 0,
  totalLessons = 0,
  onReview,
  reviewMode,
  onContinue,
  onCardClick,
}) => {
  const getStatusColor = () => {
    switch (status) {
      case "completed":
        return "course-list-card-status-completed";
      case "in-progress":
        return "course-list-card-status-progress";
      default:
        return "course-list-card-status-default";
    }
  };

  const getProgressColor = () => {
    if (progress >= 75) return "#4CAF50";
    if (progress >= 50) return "#FFC107";
    return "#ff6b38";
  };

  return (
    <div
      className="course-list-card"
      role="article"
      onClick={onCardClick}
      style={{ cursor: onCardClick ? "pointer" : undefined }}
    >
      <div className="course-list-card-thumbnail">
        <img src={thumbnail} alt={`${title} course thumbnail`} loading="lazy" />
        <div className={`course-list-card-status-badge ${getStatusColor()}`}>
          {status.replace("-", " ")}
        </div>
      </div>
      <div className="course-list-card-info">
        <div className="course-list-card-meta">
          <span className="course-list-card-category">{category}</span>
          <span className="course-list-card-instructor">{instructor}</span>
        </div>
        <h3 title={title}>{title}</h3>
        <div className="course-list-card-footer">
          <button
            className="course-list-card-watch-btn"
            aria-label={`${
              status === "completed"
                ? reviewMode
                  ? "Update Review"
                  : "Review"
                : "Continue"
            } ${title} course`}
            onClick={(e) => {
              e.stopPropagation();
              if (status === "completed" && onReview) {
                onReview();
              } else if (status === "in-progress" && onContinue) {
                onContinue();
              }
            }}
          >
            {status === "completed"
              ? reviewMode
                ? "Update Review"
                : "Review Course"
              : "Continue Learning"}
          </button>
          <div className="course-list-card-progress-status">
            <div className="course-list-card-progress-wrapper">
              <div
                className="course-list-card-progress"
                role="progressbar"
                aria-valuenow={progress}
                aria-valuemin="0"
                aria-valuemax="100"
              >
                <div
                  className="course-list-card-progress-bar"
                  style={{
                    width: `${progress}%`,
                    backgroundColor: getProgressColor(),
                  }}
                />
              </div>
            </div>
            <span className="course-list-card-completion-text">
              {progress}% Completed{" "}
              {totalLessons > 0 &&
                `(${completedLessons}/${totalLessons} lessons)`}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

CourseCard.propTypes = {
  thumbnail: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  progress: PropTypes.number.isRequired,
  instructor: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  status: PropTypes.oneOf(["completed", "in-progress"]).isRequired,
  completedLessons: PropTypes.number,
  totalLessons: PropTypes.number,
  onReview: PropTypes.func,
  reviewMode: PropTypes.bool,
  onContinue: PropTypes.func,
  onCardClick: PropTypes.func,
};

export default CourseCard;
